<template>
  <div>
    <div class="card">
      <div class="card-body">
        <ul class="list-group list-group-flush">
          <li
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <span class="text-paragraph">Status</span>
            <span class="text-subtitle" :style="{ color: item.status_color }"
              >{{ item.status_label }}
              <i v-if="item.status_icon" :class="`fa-solid fa-${item.status_icon}`"></i>
            </span>
          </li>
          <li
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <span class="text-paragraph"> Tipo de sessão</span>
            <span class="text-subtitle">{{ formattedType }}</span>
          </li>
          <li
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <span class="text-paragraph">Dia</span>
            <span class="text-subtitle">{{ item.formatted_date }}</span>
          </li>
          <li
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <span class="text-paragraph">Horário</span>
            <span class="text-subtitle">
              <TimezoneAlert />
              das {{ item.formatted_time }}</span
            >
          </li>
          <li
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <span class="text-paragraph">Duração</span>
            <span class="text-subtitle">50 minutos</span>
          </li>
          <li
            class="list-group-item d-flex justify-content-between align-items-center"
            v-if="item.can_reschedule"
          >
            <Button
              outline
              fullWidth
              label="Reagendar sessão"
              @onClick="handleReschedule"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { Appointment } from "@phurshell/psiapp-frontend-core/domain";
import {
  EOffcanvasViews,
  navigateCanvas,
  OffcanvasViewsConfig,
} from "@/views/OffcanvasViews/OffcanvasViewsConfig";

const props = defineProps<{ item: Appointment }>();

const formattedType = computed(() =>
  props.item.type === "imediate" ? "Imediata" : "Agendada"
);

function handleReschedule() {
  navigateCanvas(
    EOffcanvasViews.reschedule_appointment,
    {
      ...OffcanvasViewsConfig.reschedule_appointment,
      props: { appointmentId: props.item.id },
    },
    false
  );
}
</script>
